import machineryReducer from "./machineryReducer"
export default machineryReducer